import { ref, computed } from 'vue'
import { defineStore } from 'pinia'

export interface LocalSettings {
  // Legacy fields - kept for backward compatibility during migration
  selectedAgentId?: string | null
  selectedScaleDeskId?: string | null
}

export const useLocalSettingsStore = defineStore('localSettings', () => {
  // State
  const settings = ref<LocalSettings>({})

  // Load settings from localStorage on initialization
  const loadSettings = () => {
    try {
      const stored = localStorage.getItem('scrapboss-local-settings')
      if (stored) {
        const parsed = JSON.parse(stored)
        settings.value = { ...settings.value, ...parsed }
      }
    } catch (error) {
      console.error('Failed to load local settings:', error)
    }
  }

  // Save settings to localStorage
  const saveSettings = () => {
    try {
      localStorage.setItem('scrapboss-local-settings', JSON.stringify(settings.value))
    } catch (error) {
      console.error('Failed to save local settings:', error)
    }
  }

  // Actions - Legacy methods kept for backward compatibility
  const setSelectedAgent = (agentId: string | null) => {
    settings.value.selectedAgentId = agentId
    saveSettings()
  }

  const setSelectedScaleDesk = (scaleDeskId: string | null) => {
    settings.value.selectedScaleDeskId = scaleDeskId
    saveSettings()
  }

  const clearSettings = () => {
    settings.value = {}
    saveSettings()
  }

  // Computed - Legacy computed properties
  const hasSelectedAgent = computed(() => !!settings.value.selectedAgentId)
  const hasSelectedScaleDesk = computed(() => !!settings.value.selectedScaleDeskId)

  // Initialize
  loadSettings()

  return {
    // State
    settings,

    // Computed
    hasSelectedAgent,
    hasSelectedScaleDesk,

    // Actions
    setSelectedAgent,
    setSelectedScaleDesk,
    clearSettings,
    loadSettings,
    saveSettings,
  }
})
